export default __webpack_public_path__ + "static/Products-pe-1844e77e8ff414438d01a8d6d447c64b.png";